import { render, staticRenderFns } from "./SalesRating.vue?vue&type=template&id=a7a6b4ca&scoped=true"
import script from "./SalesRating.vue?vue&type=script&lang=js"
export * from "./SalesRating.vue?vue&type=script&lang=js"
import style0 from "./SalesRating.vue?vue&type=style&index=0&id=a7a6b4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a6b4ca",
  null
  
)

export default component.exports